export {
  AccountsMenuLinks,
  logOutLink,
  moveZapsLink,
  settingsLink,
  topNavFallbackData,
  usageLink,
} from './links';
export type {
  ArticleStubType,
  CallToAction,
  LinkIconType,
  PromoLinksListType,
  TopBarLinksType,
  UniversalNavLinkType,
} from './links';

export type TrialPlanTypes = 'Professional' | 'Team' | 'Company';

// Account action paths
export const signupPath = '/sign-up/';
export const loginPath = '/app/login';

// Utility constants
export const skipLinkHref = '#mainContent';
export const UNIVERSAL_NAV_ZINDEX = 950;
export const UNIVERSAL_NAV_SUBMENU_ZINDEX = UNIVERSAL_NAV_ZINDEX + 1;
export const UNIVERSAL_TOPBAR_HEIGHT = 70;
export const UNIVERSAL_TOPBAR_CONDENSED_HEIGHT = 60;
export const UNIVERSAL_SIDEBAR_WIDTH = 300;
export const UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH = 70;
